
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentInjectedEvidenceHtml } from "../../../../../../../domain/document";
import InjectedObjectEvidencePresentableMixin from "./InjectedObjectEvidencePresentableMixin.vue";

@Component
export default class InjectedObjectEvidenceHtmlPresentableMixin extends Mixins(InjectedObjectEvidencePresentableMixin) {
  @Prop()
  source: DocumentInjectedEvidenceHtml;

  get html(): string {
    // TODO: サニタイズ.
    return this.source.html;
  }
}
